export default "__VITE_ASSET__fc6eaf35__"